import {atom} from "recoil";

export const AppsFilterAtom = atom({
    key: 'app-filters',
    default: {
        modules: [],
        subscriptionType: "0",
        priceRange: [0, 50000000 ],
        search: ""
    }
})